import * as React from 'react';

const SvgCalendar = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="calendar-check-02">
      <path
        id="Fill"
        opacity={0.12}
        d="M1.95703 5.86406C1.95703 4.74396 1.95703 4.18391 2.17035 3.75608C2.35798 3.37976 2.65739 3.0738 3.02565 2.88205C3.44431 2.66406 3.99236 2.66406 5.08846 2.66406H10.5685C11.6646 2.66406 12.2126 2.66406 12.6313 2.88205C12.9995 3.0738 13.2989 3.37976 13.4866 3.75608C13.6999 4.18391 13.6999 4.74396 13.6999 5.86406V6.66406H1.95703V5.86406Z"
        fill="#0E0C0F"
      />
      <path
        id="Icon"
        d="M13.6999 6.66927H1.95703M13.6999 8.33594V5.86927C13.6999 4.74917 13.6999 4.18911 13.4866 3.76129C13.2989 3.38497 12.9995 3.079 12.6313 2.88726C12.2126 2.66927 11.6646 2.66927 10.5685 2.66927H5.08846C3.99236 2.66927 3.44431 2.66927 3.02565 2.88726C2.65739 3.079 2.35798 3.38497 2.17035 3.76129C1.95703 4.18911 1.95703 4.74917 1.95703 5.86927V11.4693C1.95703 12.5894 1.95703 13.1494 2.17035 13.5773C2.35798 13.9536 2.65739 14.2595 3.02565 14.4513C3.44431 14.6693 3.99236 14.6693 5.08846 14.6693H7.82846M10.438 1.33594V4.0026M5.21894 1.33594V4.0026M9.45941 12.6693L10.7642 14.0026L13.6999 11.0026"
        stroke="#0E0C0F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgCalendar;
